<template>
  <div style="marging-top: 6px; height: 400px; overflow: hidden">
    <div style="height: 30px">
      <el-button type="primary" size="mini" style="float: right; margin-right: 30px; margin-top: 10px"
        @click="editInfo">{{ EditCancel }}</el-button>

      <el-button type="primary" size="mini" style="float: right; margin-right: 10px; margin-top: 10px"
        @click="gotoLists">{{ $t("message.button.return") }}
      </el-button>

      <el-button type="success" size="mini" style="float: right; margin-right: 10px; margin-top: 10px"
        @click="submitForm" v-if="edit">{{ $t("message.button.save") }}</el-button>
    </div>

    <ul v-if="!edit" style="position: relative; overflow: hidden; list-style: none; width: 100%">
      <li v-for="item in tabViewData" style="width: 100%" :key="item.index">
        <div class="table-list">
          <span class="list-key-1">{{ item.name }}</span>
          <span style="display: inline-block; margin: 0 6px">:</span>
          <span class="list-val">{{ item.val }}</span>
        </div>
      </li>
    </ul>
    <el-form v-else :model="listInfo" ref="ruleForm" label-width="200px" class="demo-ruleForm" size="small">
      <el-form-item :label="$t('message.table.name')" prop="name" required>
        <el-input v-model="listInfo.name" :style="input_width"></el-input>
      </el-form-item>

      <el-form-item :label="$t('message.table.type')" required>
        <el-select disabled v-model="listInfo.listType" :placeholder="$t('message.placeholder.select')" size="small"
          :style="input_width">
          <el-option v-for="item in listType" :label="item.label" :value="item.value" :key="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('message.table.des')">
        <el-input v-model="listInfo.description" :style="input_width"></el-input>
      </el-form-item>

      <el-form-item :label="$t('message.table.status')">
        <el-select v-model="listInfo.enabled" :placeholder="$t('message.placeholder.select')" size="small"
          :style="input_width">
          <el-option v-for="item in enabledList" :label="item.label" :value="item.value" :key="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-if="listInfo.listType == 4" :label="$t('message.table.codeValueLength')" prop="codeValueLength"
        required>
        <el-input v-model="listInfo.codeValueLength" :style="input_width" @blur="filterNumberLength"></el-input>
      </el-form-item>

      <el-form-item v-if="listInfo.listType == 3" :label="$t('message.table.criteria')">
        <el-select v-model="listInfo.criteria" :style="input_width" :placeholder="$t('message.placeholder.select')"
          size="small" style="width:100%">
          <el-option v-for="item in seekList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <!-- <el-form-item :label="$t('message.table.displayType')">
        <el-select
          v-model="listInfo.displayType "
          :placeholder="$t('message.placeholder.select')"
          size="small"
          :style="input_width"
        >
          <el-option v-for="item in displayType" :label="item.label" :value="item.value" :key="item.value"></el-option>
        </el-select>
      </el-form-item> -->

      <!-- <el-form-item>
        <el-button @click="reset">{{ $t("message.button.reset") }}</el-button>
      </el-form-item> -->
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      EditCancel: this.$t("message.button.edit"),
      edit: false,
      input_width: {
        width: "50%",
      },

      tabViewData: [
        {
          name: this.$t("message.table.name"),
          id: "name",
          val: "",
        },
        {
          name: this.$t("message.table.listType"),
          id: "listType",
          val: "",
        },
        {
          name: this.$t("message.table.des"),
          id: "description",
          val: "",
        },
        {
          name: this.$t("message.table.status"),
          id: "enabled",
          val: "",
        },
        {
          name: this.$t("message.table.codeValueLength"),
          id: "codeValueLength",
          val: "",
        },
      ],
      editForm: {},

      seekList: [],

      listType: [
        { label: this.$t("message.table.simple"), value: 1 },
        { label: this.$t("message.table.cascade"), value: 2 },
        { label: this.$t("message.table.dynamic"), value: 3 },
        { label: this.$t("message.table.code"), value: 4 },
        { label: this.$t("message.table.serialNumber"), value: 5 },
        { label: this.$t("message.table.versionNumber"), value: 6 },
        { label: this.$t("message.table.reference"), value: 7 },
      ],
      enabledList: [
        { label: this.$t("message.table.enabled"), value: 1 },
        { label: this.$t("message.table.disabled"), value: 0 },
      ],
      listInfo: JSON.parse(this.$route.query.row)
      // displayType:[
      //   {label: this.$t('message.table.list'),value:1},
      //   {label: this.$t('message.table.search'),value:2},
      // ],
    };
  },
  // props: ["listInfo"],
  methods: {
    filterNumberLength(e) {
      let n = parseInt(this.listInfo.codeValueLength);
      let arr = (this.listInfo.codeValueLength + "").split("");
      this.listInfo.codeValueLength =
        n < arr.length || isNaN(n) ? arr.length : n;
    },
    gotoLists() {
      //返回显示所有list窗口
      // console.log("gotoPPMWorkflowList");
      this.$router.push("/Lists");
    },
    editInfo() {
      this.edit = !this.edit;
      console.log(this.editForm);
      // if (this.editForm.listType == 3 && !this.seekList.length) {
      //   axios.get("/pmdm/admin/criteria/getSeekList").then((res) => {
      //     this.seekList = res.data.Object.seekList.map((i) => ({
      //       label: i.name,
      //       value: i.id,
      //     }));
      //   });
      // }
    },
    reset() { },
    getInfo() {
      console.log(this.listInfo);
      let m = this.listInfo;
      // for (const i of m) {
      //   if (i == 'listType' ||i == 'enabled'||i == 'displayType') {
      //     parseInt(m[i]);
      //   }
      // }
      // let arr = ['listType' ,'enabled','displayType']
      let arr = ["listType", "enabled"];
      Object.keys(m).forEach((i) => {
        if (arr.includes(i)) {
          // console.log(m[i]);
          m[i] = parseInt(m[i]);
        }
      });
      console.log(m);
      // m.map(Number);
      // m.listType = {
      //   val:m.listType,
      //   label:this.listType.filter(i=> i.val == m.listType)[0].label
      // }
      // m.status = {
      //   val:m.enabled,
      //   label:this.enabledList.filter(i=> i.val == m.enabled)[0].label
      // }
      // m.displayType = {
      //   val:m.displayType,
      //   label:this.displayType.filter(i=> i.val == m.displayType)[0].label
      // }
      this.tabViewData = [
        { name: this.$t("message.table.name"), val: m.name },
        {
          name: this.$t("message.table.listType"),
          id: m.listType,
          val: this.listType.filter((i) => i.value == m.listType)[0].label,
        },
        { name: this.$t("message.table.des"), val: m.description },
        {
          name: this.$t("message.table.status"),
          id: m.enabled,
          val: this.enabledList.filter((i) => i.value == m.enabled)[0].label,
        },
        // { name:this.$t('message.table.displayType'),id:m.displayType,val:this.displayType.filter(i => i.value == m.displayType)[0].label},
      ];
      if (m.listType == 4) {
        this.tabViewData.push({
          name: this.$t("message.table.codeValueLength"),
          val: m.codeValueLength
        });
      }
      if (m.listType == 3 && !this.seekList.length) {
        axios.get("/pmdm/admin/criteria/getSeekList").then((res) => {
          this.seekList = res.data.object.seekList.map((i) => ({
            label: i.name,
            value: i.id,
          }));
          console.log(this.seekList);
          this.tabViewData.push({
            name: this.$t("message.table.criteria"),
            val: m.criteria == -1 ? '' : this.seekList.find(i => i.value == m.criteria).label
          });
        });
      }

      console.log(this.tabViewData);
      // this.editForm = {
      //   name:,
      //   des:,
      //   enabled:
      //   listType:,
      //   displayType:,
      // }
    },
    submitForm() {
      // if (this.listNames.includes(this.createForm.name)) {
      //   this.$message.error(this.$t('message.error.nameUsed'))
      //   return
      // }

      let obj = this.listInfo;
      Object.assign(obj, { id: this.$store.state.listId });
      obj.parent = JSON.stringify(obj.parent) == "{}" ? "" : obj.parent;
      obj.parentEntry =
        JSON.stringify(obj.parentEntry) == "{}" ? "" : obj.parentEntry;
      obj.displayType =
        JSON.stringify(obj.displayType) == "{}" ? 1 : obj.displayType;
      obj.codeValueLength =
        JSON.stringify(obj.codeValueLength) == "{}" ? "" : obj.codeValueLength;

      console.log(obj);
      axios
        .post("/pmdm/admin/list/updateList", obj)
        .then((res) => {
          this.getInfo();

          this.$message({
            message: res.data.message,
            type: "success",
          });
          this.edit = !this.edit;
          this.$emit("change", this.listInfo.name);
        })
        .catch(function (error) {
          console.log(error);
        });

      // var vm = this;
      // // console.log(this.editForm);
      // // console.log(this.old_data);
      // for (var key in this.editForm) {
      // 	if (this.editForm[key] !== this.old_data[key]) {
      // 		obj[key] = this.editForm[key];
      // 	};
      // };
      // if (JSON.stringify(obj) == '{}') {
      // 	this.closeInfo()
      // } else {

      // };
      // console.log(obj);
    },
  },
  created() {
    this.getInfo();
    console.log(this.$route.query);
  },
  watch: {
    edit(e) {
      if (e) {
        this.EditCancel = this.$t("message.button.cancel");
      } else {
        this.EditCancel = this.$t("message.button.edit");
      }
    },
  },
};
</script>

<style></style>
